import React, {Component} from 'react'
import List from '@material-ui/core/List'
import * as Icons from 'components/icons'
import StyleSheet from 'styles'
import IconButton from '@material-ui/core/IconButton'
import {connect} from 'react-redux'
import {NotificationActions, UserSelectionActions, SnackbarActions} from 'actionsets'
import Tooltip from '@material-ui/core/Tooltip'
import {Pagination} from 'components'
import Typography from '@material-ui/core/Typography'
import Dependent from 'containers/shared/Dependent'
import {Authorization} from 'utils'
import {ConfirmationDialog} from 'components'
import TextField from '@material-ui/core/TextField'
import {CenteredContent, User} from 'containers'
import {NotificationItem} from '.'

export class NotificationsList extends Component {

  constructor(props) {
    super(props)
    NotificationActions.bindActions(this)
    UserSelectionActions.bindActions(this, 'userSelect')
    SnackbarActions.bindActions(this, 'snackbar')
    this.state = {
      currentPage: 0,
      postNotificationDialog: {
        open: false,
        title: '',
        message: ''
      }
    }
  }

  dependsOn() {
    return Promise.all([
      this.actions.show(this.state.currentPage),
      this.actions.unreadCount()
    ])
  }

  dependenciesMet() {
    return this.props.requests.filter(r => r.type === NotificationActions.SHOW).length === 0
  }

  get totalPages() {
    return this.props.totalPages || 0
  }

  get currentPage() {
    return Math.max(this.state.currentPage, 1)
  }

  set currentPage(value) {
    this.setState({
      currentPage: value
    })
    this.actions.show(value)
  }

  handleOpenNotificationDialog = () => {
    this.setState({postNotificationDialog: {...this.state.postNotificationDialog, open: true, title: '', body: ''}})
  }

  handlePostNotification = async () => {
    this.setState({postNotificationDialog: {...this.state.postNotificationDialog, open: false}})
    try {
      const {title, message} = this.state.postNotificationDialog
      const userIds = await this.actions.userSelect.makeSelection({
        title: 'Send to users:',
        actionName: 'Send Notification'
      })
      await this.actions.create({title, message, userIds})
      this.actions.snackbar.success("Notification posted")
    } catch (cancel) {
      // pass
    }
    this.actions.show(this.state.currentPage)
  }

  handleCancelNotification = () => {
    this.setState({postNotificationDialog: {...this.state.postNotificationDialog, open: false}})
  }

  handleNotificationClick = url => () => {
    if (!url) return
    this.props.history.push(url)
  }

  handleSetNotificationTitle = ({target: {value: title}}) => {
    this.setState({postNotificationDialog: {...this.state.postNotificationDialog, title}})
  }

  handleSetNotificationContent = ({target: {value: message}}) => {
    this.setState({postNotificationDialog: {...this.state.postNotificationDialog, message}})
  }

  handleToggleRead = (ids, read) => async (event) => {
    await read ? this.actions.markAsUnread(ids) : this.actions.markAsRead(ids)
    this.actions.unreadCount()
    this.actions.show(this.state.currentPage)
  }

  render = () =>
    <CenteredContent>
      <div className={styles.heading}>
        <Typography variant='h5'>Notifications</Typography>
        <div>
          {Authorization.admin &&
          <Tooltip title="Send new Notification" placement="bottom">
            <IconButton onClick={this.handleOpenNotificationDialog} className={styles.iconButton}>
              <Icons.Add/>
            </IconButton>
          </Tooltip>
          }
          <Tooltip title="Refresh Notifications" placement="bottom">
            <IconButton onClick={() => this.actions.show(this.state.currentPage)} className={styles.iconButton}>
              <Icons.Reload/>
            </IconButton>
          </Tooltip>
          <Tooltip title="Mark all as read" placement="bottom-end">
            <IconButton onClick={this.handleToggleRead(this.props.notifications.map(({id}) => id))}
                        className={styles.iconButton}>
              <Icons.AcceptAll/>
            </IconButton>
          </Tooltip>
        </div>
      </div>
      <List>
        {this.props.notifications.map(notification =>
          <NotificationItem
            onClick={this.handleNotificationClick(notification.linkTo)}
            onToggleRead={this.handleToggleRead([notification.id], notification.read)}
            className={styles.listItem} notification={notification}
          />
        )}
        {!this.props.notifications.length &&
          <Typography className={styles.noNotifications}>No new Notifications</Typography>
        }
      </List>
      <Pagination totalPages={this.totalPages} page={this.currentPage}
                  onPageSelected={(page) => this.currentPage = page}/>

      <ConfirmationDialog
        open={this.state.postNotificationDialog.open}
        title={"Post a new admin notification"}
        onConfirm={this.handlePostNotification}
        onCancel={this.handleCancelNotification}
        canConfirm={!!(this.state.postNotificationDialog.title.trim() && this.state.postNotificationDialog.message.trim())}
      >
        <div className={styles.notificationDialogBody}>
          <TextField placeholder='Title' autoFocus={true} className={styles.notificationDialogTextField}
                     onChange={this.handleSetNotificationTitle}/>
          <TextField rows={10} multiline={true} placeholder='Message' className={styles.notificationDialogTextField}
                     onChange={this.handleSetNotificationContent}/>
        </div>
      </ConfirmationDialog>

      <User.UserSelect/>
    </CenteredContent>
}

const styles = StyleSheet({
  wrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  heading: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: [20, 0],
    '& h5': {
      flex: 1
    }
  },
  noNotifications: {
    padding: 10
  },
  notificationMenuItem: {
    height: 'auto',
    padding: 0,
    '& > div': {
      flex: 1
    }
  },
  notificationItem: {
    whiteSpace: 'normal',
    paddingLeft: 0,
    cursor: 'pointer'
  },
  notificationDialogBody: {
    width: '100%',
    maxWidth: 1200,
    background: '#efefef',
    display: 'flex',
    flexDirection: 'column'
  },
  notificationDialogTextField: {
    '& input': {
      color: 'black'
    },
    '& textarea': {
      color: 'black'
    }
  },
  listItemActions: {
    display: 'flex',
    flex: 0,
    flexDirection: 'row',
    width: 70,
    margin: 0,
    padding: 9,
    marginRight: -10,
  },
  iconButton: {
    float: 'right',
    '& svg': {
      fill: '#1B3044'
    }
  },
  listItem: {
    background: 'white',
    marginTop: 0,
    paddingLeft: 3,
    paddingRight: 3,
    borderBottom: '2px solid #f6f6f6',
    '&:first-child': {
      borderTop: '2px solid #f6f6f6',
    },
    '& .list-item-secondary': {
      display: 'block',
      fontSize: 11,
      marginTop: 10,
      color: "#888"
    }
  },
  '@media(max-width: 600px)': {
    listItemActions: {
      width: 50,
      padding: 4
    },
    listItemText: {
      cursor: 'pointer',
      '& h6': {
        fontSize: 13
      }
    }
  }
})

export default connect(({notifications}) => notifications)(Dependent({
  loader: true,
  wrapperClassName: styles.wrapper
})(NotificationsList))